import CryptoJS from 'crypto-js'

// DES加密
export const encryptDes = (message) => {
    var key = 'P9i8d7gli73673UJDD6D23ro';
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}


// WEBPACK FOOTER //
// ./src/utils/des.js